jQuery(function($){
	$('.copyrightYear').text(new Date().getFullYear());  
  
  $('.custom-gallery').slick({
    infinite:  true,
    slidesToShow: 1,
    arrows: true,
    adaptiveHeight:  true
  });
  
  $('.video-slider').slick({
    infinite:  false,
    slidesToShow: 1,
    arrows: true,
    adaptiveHeight:  true
  });
  
    // Search Page - View product and add to cart button
    $( '.template-search .grid-product__content .custom-product-btns' ).each(function() {
        $(this).find('.btn-wrap .btn-small').prependTo($(this).find('.product-single__form'));
	});

});